import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditSousActivity = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [OpenAlert, setOpenAlert] = useState(false);
  const [sousActivityData, setSousActivityData] = useState({});
  const [defaultOptionValue, setDefaultOptionValue] = useState({});
  const [activities, setActivities] = useState([]);
  const [, setSubActivity] = useState('');
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...sousActivityData };
    item[name] = value;
    setSousActivityData(item);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let activitySelected = { id: defaultOptionValue['id'], name: defaultOptionValue['name'] };
    activities.map((activity) => {
      if (activity.name === sousActivityData['activity']) {
        activitySelected = { id: activity.id, name: activity.name };
      }
      return activitySelected;
    });
    const chargeUpdate = { id: sousActivityData['id'], name: sousActivityData['name'], activity: activitySelected };
    try {
      if (sousActivityData['name'] === '' || defaultOptionValue === 'Choose activity') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        sousActivityData['name'] = props.subActivity['name'];
        setDefaultOptionValue(props.subActivity.activity);

        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/subactivity/update`, chargeUpdate);
        if ((await response).status === 200) {
          setSpinner(false);
          props.subActivities();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    sousActivityData['name'] = props.subActivity['name'];
    setDefaultOptionValue(props.subActivity.activity);
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    const getActivities = () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivities(response.data);
      });
    };
    getActivities();
    setSousActivityData(props.subActivity);
    setDefaultOptionValue(props.subActivity.activity);
  }, [httpClient, props.subActivity]);

  return (
    <>
      <EditButtonIcon
        onClick={UpdateModalToggle}
        title={props.t('update_sub_activity')}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_sub_activity')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <label htmlFor="sub_activity_name">{props.t('sub_activity_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="unit_name"
                    value={sousActivityData['name']}
                    onChange={(e) => setSubActivity(e.target.value)}
                    placeholder={props.t('enter_sub_activity_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'subActivity_activity'}>{props.t('charge_activity_name')}</label>
                  <select
                    name="activity"
                    id="subActivity_activity"
                    className="form-control"
                    value={defaultOptionValue['name']}
                    onChange={(e) => setDefaultOptionValue(e.target.value)}
                  >
                    {activities.map((activity) => (
                      <option key={activity.id} value={activity.name}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditSousActivity);
